// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul.articles-list{padding:0;color:inherit}ul.articles-list li{list-style:none}ul.articles-list li a{display:block;color:inherit;height:100%}ul.articles-list li a:hover,ul.articles-list li a:active{color:inherit;border-color:transparent;text-decoration:none;transition:border-color ease-in-out 0ms}@media (max-width: 1199.98px){ul.articles-list .card-body img{width:34%}}\n", ""]);
// Exports
module.exports = exports;
